import { render, staticRenderFns } from "./upload-swiper-images.vue?vue&type=template&id=e4db0880&scoped=true&"
import script from "./upload-swiper-images.vue?vue&type=script&lang=js&"
export * from "./upload-swiper-images.vue?vue&type=script&lang=js&"
import style0 from "./upload-swiper-images.vue?vue&type=style&index=0&id=e4db0880&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4db0880",
  null
  
)

export default component.exports